
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 5.5h-1a.5.5 0 000 1h1v3a.5.5 0 001 0v-3h1a.5.5 0 000-1h-1v-1a.5.5 0 00-1 0zM14 12a1 1 0 01-1 1H3.5a.5.5 0 00-.5.5.5.5 0 00.5.5h10a.48.48 0 01.5.48.5.5 0 01-.5.5H3.25A1.25 1.25 0 012 13.75V2.25A1.25 1.25 0 013.25 1h9.5A1.25 1.25 0 0114 2.25z"}})])
          )
        }
      }
    